import React from 'react';
import styles from './rpCollections.scss';
import moment from 'moment';

const FnfDetailsTable = ({ data = {}, handleClick }) => {
  const staticColumnList = [
    'VAN Number',
    'Amount',
    'FNF Requested At',
    'FNF Completed At',
    'Status',
    'Requested By',
    'Approved By',
    'Actions'
  ];
  return (
    <div style={{ margin: '20px' }}>
      <table className={`${styles.fnfTable}`}>
        <thead>
          <tr>
            {staticColumnList.map((column, idx) => {
              return (
                <th key={idx} className={`${styles.fnfTableHeaders}`}>
                  {column}
                </th>
              );
            })}
          </tr>
        </thead>
        <tbody>
          <tr className={`${styles.fnfTableRow}`}>
            <td>{data.orgCode || '-'}</td>
            <td>&#8377; {data.balanceAtClosure || '0'}</td>
            <td>
              {data.requestedAt
                ? moment(data.requestedAt).format("DD MMM'YY")
                : '-'}
            </td>
            <td>
              {data.approvedAt
                ? moment(data.approvedAt).format("DD MMM'YY")
                : '-'}
            </td>
            <td style={{ textTransform: 'uppercase' }}>{data.status || '-'}</td>
            <td>{data.requestedByUserName || '-'}</td>
            <td>{data.approvedByUserName || '-'}</td>
            <td style={{ opacity: 1 }}>
              <button
                type="button"
                className={`${styles.fnfBtn} ${
                  data.approvedAt ? styles.fnfBtnDisabled : ''
                }`}
                onClick={handleClick}
                disabled={data.approvedAt}
              >
                APPROVE
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default FnfDetailsTable;
